// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Countdown_countdown__xUzhW","skeleton":"Countdown_skeleton__9wriP"};